<template>
  <div class="container project-settings">
    <div class="project-settings__tabs">
      <router-link class="project-settings__tabs_tab"
                   :to="{ name: 'AccountTab' }"
                   active-class="project-settings__tabs_tab_active">Account</router-link>
      <router-link class="project-settings__tabs_tab"
                   :to="{ name: 'StrategyTab' }"
                   active-class="project-settings__tabs_tab_active">Strategy Settings</router-link>
      <router-link class="project-settings__tabs_tab"
                   :to="{ name: 'RankTrackingTab' }"
                   active-class="project-settings__tabs_tab_active">Rank Tracking</router-link>
      <router-link class="project-settings__tabs_tab"
                   :to="{ name: 'PublishingTab' }"
                   active-class="project-settings__tabs_tab_active">Publishing</router-link>
      <router-link class="project-settings__tabs_tab"
                   :to="{ name: 'integrations' }"
                   active-class="project-settings__tabs_tab_active">Integrations</router-link>
      <router-link class="project-settings__tabs_tab"
                   :to="{ name: 'ShopPropertiesTab' }"
                   active-class="project-settings__tabs_tab_active">Shop Properties</router-link>
      <button v-if="isUserSuperAdmin" @click.prevent="triggerAgg" class="project-settings__tabs_btn project-settings__button project-settings__button_submit">
        Trigger New Aggregation
      </button>
    </div>
    <div v-if="!isDataFetched">
      <div class="project-settings__no-data">Awaiting Data</div>
    </div>
    <template v-else>
       <router-view />
    </template>

    <div class="project-settings__update-loader" v-if="isDataUpdating">
      <base-loader class="project-settings__update-loader-ring"/>
    </div>

  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'ProjectSettings',
  data () {
    return {
      isDataFetched: false,
      isDataUpdating: false,
    }
  },
  props: {
    projectId: {
      type: String,
      required: false
    }
  },
  watch: {
    clientId: {
      handler (clientId) {
        if (!this.isDataUpdating) {
          clientId && this.loadData()
        }
      },
      immediate: true
    },
  },
  computed: {
    isUserSuperAdmin () {
      return this.userRoles.includes('admin')
    },
  },
  methods: {
    ...mapActions('projectSettings', ['getProjectSettings']),
    ...mapActions('client', ['createClientAggregation']),
    async triggerAgg () {
      this.isDataUpdating = true
      await this.createClientAggregation(this.clientId)
      this.isDataUpdating = false
    },
    async loadData () {
      this.isDataUpdating = true
      if (this.projectId) {
        await this.setNewClient(this.projectId)
      }
      await this.getProjectSettings(this.clientId)
      this.isDataUpdating = false
      this.isDataFetched = true
    },
  }
}
</script>

<style scoped lang="scss">
  .project-settings {
    padding-top: 14px;
    position: relative;
    // min-height: 50vh !important;

    &__button {
      width: 200px;
      margin-left: 30px;



      min-width: 100px;
      padding: 0 25px;
      height: 40px;
      font-size: 10px;
      font-weight: 900;
      cursor: pointer;
      text-transform: uppercase;
      border-radius: 8px;
      outline: none;
      border: none;
      
      &_submit {
        background-color: $rfx-dark-march;
        color: #fff;
      }
    }
    &__tabs {
      display: flex;
      margin-bottom: -1px;

      &_btn {
        margin-left: auto;
      }
      &_tab {
        width: max-content;
        padding: 16px 9px;
        text-align: center;
        font-size: 14px;
        color: $rfx-light-march;
        background-color: transparent;
        border: 1px solid transparent;
        text-decoration: none;

        &_error {
          color: $rfx-red;
        }

        &_active {
          background-color: #fff;
          color: $rfx-dark-march;
          font-weight: bold;
          border: 1px solid $rfx-light-steel;
          border-bottom: 1px solid #fff;
        }
      }
    }


    &__title-left {
      display: flex;
      align-items: center;
    }

    &__title-left > *:not(:last-child) {
      margin-right: 30px;
    }

    &__title-container {
      padding: 14px 0;
      display: flex;
      align-items: center;
    }

    &__no-data {
      display: flex;
      height: 300px;
      background-color: #fff;
      border-radius: $rfx-default-border-radius;
      align-items: center;
      justify-content: center;
      font-size: 27px;
      font-weight: 600;
      color: $rfx-medium-grey;
      flex: 1 1;
    }

    &__update-loader {
      position: absolute;
      display: flex;
      width: 100%;
      height: 100%;
      justify-content: center;
      background-color: white;
      top: 0;
      opacity: 0.5;
      z-index: 10000;
    }

    &__update-loader-ring {
      margin-top: 200px;
    }

    &__table-wrapper {
      width: 100%;
      display: flex;
      flex-direction: column;
      border-top: 1px solid $rfx-light-steel;
      border-left: 1px solid $rfx-light-steel;
      border-right: 1px solid $rfx-light-steel;
      border-radius: $rfx-default-border-radius;
    }

    &__table-row {
      display: flex;
      width: 100%;
      background-color: #fff;
      border-bottom: 1px solid $rfx-light-steel;

      &:first-child {
        border-top-left-radius: $rfx-default-border-radius;
        border-top-right-radius: $rfx-default-border-radius;

        input {
          border-top-right-radius: $rfx-default-border-radius;
        }
      }

      &:last-child {
        border-bottom-left-radius: $rfx-default-border-radius;
        border-bottom-right-radius: $rfx-default-border-radius;
      }

      &__title {
        color: $rfx-dark-march;
        flex: 1;
        font-weight: bold;
        padding: 15px 0 15px 25px;
        font-size: 14px;
        border-right: 1px solid $rfx-light-steel;
      }

      &__field {
        flex: 2;
        padding: 15px 0 15px 25px;
        border: 1px solid transparent;

        &_err {
          border: 1px solid $rfx-light-red !important;
        }

        &::placeholder {
          color: $rfx-dark-march;
        }
      }
    }

    &__select {
      padding: 3px 0 3px 25px !important;
      height: 60px !important;

      &::v-deep .select__input {
        position: relative;
        left: -22px;
        padding-left: 22px;
      }

      &::v-deep .select__input-container {
        background-color: #fff;
        margin-left: -4px;
      }

    }

    &__field_disabled {
      pointer-events: none !important;
    }

    &__footer {
      margin-top: 40px;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      &__button {
        min-width: 100px;
        padding: 0 25px;
        height: 40px;
        font-size: 10px;
        font-weight: 900;
        cursor: pointer;
        text-transform: uppercase;
        border-radius: 8px;
        outline: none;
        border: none;
        color: #fff;
        background-color: $rfx-dark-march;
      }
    }
  }
</style>
